import inflection from "inflection";
import { Component } from "preact";
import csstyle from "tpm-lib/widgets/csstyle.js";

export default class Widget extends Component {
	get widgetName() {
		return inflection.camelize(this.constructor.typeName);
	}

	get refs() {
		const _refs = {};
		Object.defineProperty(this, "refs", {
			get() {
				return _refs;
			},
		});
		return _refs;
	}

	getBaseProps() {
		return {
			className: this.componentClasses(),
			ref: (x) => (this.refs.base = x),
		};
	}

	// given this.widgetName === "MyWidget":
	//   this.componentClasses() => "MyWidget"
	//   this.componentClasses('NestedThing') => "NestedThing"
	//   this.componentClasses('NestedThing', { span: 2 }) => "NestedThing"
	componentClasses(name) {
		return csstyle(name || this.widgetName);
	}

	// given this.widgetName === "MyWidget":
	//   this.partClasses('Foo') => "MyWidget__Foo"
	//   this.partClasses('NestedThing', 'Foo') => "NestedThing__Foo "
	partClasses(name, part, opts) {
		if ("string" !== typeof part) {
			(opts = part), (part = name), (name = this.widgetName);
		}

		return csstyle(name, part);
	}

	render(props, state) {
		return (
			<div {...this.getBaseProps()}>{this.renderContent(props, state)}</div>
		);
	}

	// static row(...grids) {
	// 	return <div className="row">{grids}</div>;
	// }

	// static row({ children, cols, ...props }) {
	// 	const rowClass = cols ? `row-${cols}` : "row";
	// 	props.className = props.className || "";
	// 	props.className = `${props.className}${props.className && " "}${rowClass}`;
	// 	props.className += "";
	// 	return <div {...props}>{children}</div>;
	// }
}
